/* Infinite scroll for collection grid (Shopify Closer, 2026-10-13). Remove script tag in sections/main-collection.liquid to disable. */
(function () {
  if (window.__okInfScroll) return; window.__okInfScroll = true;
  var LOADING = false, MARGIN = 1200;
  function grid() { return document.getElementById('CollectionProductGrid'); }
  function setup(g) {
    if (!g || fresh(g)) return;
    var old = g.querySelector('.ok-inf-sentinel'); if (old) old.remove();
    LOADING = false;
    g.__inf = { next: null, done: false, ul: g.querySelector('ul.collection-list') };
    var a = g.querySelector('.pagination li:last-child a[href]');
    if (a) { g.__inf.next = a.href; } else { g.__inf.done = true; }
    var pag = g.querySelector('.pagination');
    if (pag && pag.parentElement) pag.parentElement.style.display = 'none';
    if (!g.__inf.done) {
      var s = document.createElement('div');
      s.className = 'ok-inf-sentinel'; s.setAttribute('aria-live', 'polite');
      s.style.cssText = 'text-align:center;padding:24px 0;font-size:14px;opacity:.7;';
      g.appendChild(s);
      // fallback link in case JS fetch fails
    }
    check();
  }
  function fresh(g) { return g.__inf && g.__inf.ul === g.querySelector('ul.collection-list'); }
  function stripPlaceholders(ul) {
    ul.querySelectorAll(':scope > li[aria-hidden="true"]').forEach(function (li) { li.remove(); });
  }
  function load(g) {
    var st = g.__inf; if (LOADING || st.done || !st.next) return;
    LOADING = true;
    var s = g.querySelector('.ok-inf-sentinel'); if (s) s.textContent = 'Ładowanie…';
    var url = st.next;
    fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (!g.isConnected || g.__inf !== st || !fresh(g)) return; // grid replaced meanwhile (filter/sort)
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('CollectionProductGrid');
        var ul = g.querySelector('ul.collection-list'), nul = ng && ng.querySelector('ul.collection-list');
        if (!ul || !nul) { st.done = true; return; }
        var last = !ng.querySelector('.pagination li:last-child a[href]');
        stripPlaceholders(ul);
        Array.prototype.slice.call(nul.children).forEach(function (li) {
          if (!last && li.getAttribute('aria-hidden') === 'true') return;
          ul.appendChild(document.importNode(li, true));
        });
        var a = ng.querySelector('.pagination li:last-child a[href]');
        st.next = a ? new URL(a.getAttribute('href'), location.href).href : null;
        st.done = !st.next;
        var pa = g.querySelector('.pagination li:last-child a[href]');
        if (pa) { if (st.next) pa.href = st.next; else pa.removeAttribute('href'); }
        if (window.lazySizes && lazySizes.loader) lazySizes.loader.checkElems();
        document.dispatchEvent(new CustomEvent('okInfScroll:loaded', { detail: { url: url } }));
      })
      .catch(function () { st.done = true; var p = g.querySelector('.pagination'); if (p) p.parentElement.style.display = ''; })
      .then(function () {
        if (g.__inf === st) LOADING = false;
        var s2 = g.querySelector('.ok-inf-sentinel');
        if (s2) { if (st.done) s2.remove(); else s2.textContent = ''; }
        if (!st.done) setTimeout(check, 50);
      });
  }
  function check() {
    var g = grid(); if (!g) return;
    if (!fresh(g)) return setup(g);
    if (g.__inf.done || LOADING) return;
    var rect = g.getBoundingClientRect();
    if (rect.bottom - window.innerHeight < MARGIN) load(g);
  }
  var t; function onScroll() { if (t) return; t = setTimeout(function () { t = null; check(); }, 120); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  new MutationObserver(function () { var g = grid(); if (g && !fresh(g)) setup(g); })
    .observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
